import {
  Avatar,
  Box,
  Flex,
  Text,
  useClipboard,
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuItem,
  VStack,
} from "@chakra-ui/react";
import avatarSrc from "@/assets/images/sw_avatar.png";
import { useEffect, useRef, useState } from "react";
import { ChatContent } from "@/types/writing";
import {
  RiCodeSLine,
  RiDeleteBin4Line,
  RiFileCopy2Line,
  RiMore2Line,
  RiRefreshLine,
} from "@remixicon/react";
import Typed from "typed.js";
import { useAppDispatch } from "@/store/hooks";
import { updateChatMsg } from "@/reducer/chatSlice";
import Markdown from "react-markdown"
type Props = {
  sessionContent: ChatContent;
  reAnswer: (chatMsg: ChatContent) => void;
  isLast?: boolean;
};

const AiSessionItem2 = (props: Props) => {
  const { sessionContent, reAnswer, isLast } = props;
  const [hovered, setHovered] = useState(false);
  const { onCopy } = useClipboard(sessionContent.message);
  const dispatch = useAppDispatch()
  const ref = useRef<HTMLSpanElement>(null)

  const handleMouseEnter = () => {
    setHovered(true);
  };
  const handleMouseLeave = () => {
    setHovered(false);
  };

  const handleCopy = () => {
    onCopy();
  };

  const handleDelete = () => { };

  useEffect(() => {
    var typed: Typed | null = null;
    if (sessionContent.once) {
      typed = new Typed(ref.current, {
        strings: [sessionContent.message],
        typeSpeed: 0,
        backSpeed: 0,
        backDelay: 500,
        startDelay: 1000,
        loop: false,
        onComplete: function (self) {
          if (sessionContent.once) {
            var content = { ...sessionContent, once: false }
            dispatch(updateChatMsg(content))
            typed && typed.destroy()
          }
        },
      });
    }

    return () => {
      typed && typed.destroy()
    }
  }, []);

  return (
    <Flex alignItems="flex-start" mb="30px">
      <Avatar
        mr="14px"
        w="40px"
        h="40px"
        name="ALDGPT"
        borderRadius={"2px"}
        src={avatarSrc}
      />
      <Box maxW={"70%"}>
        <Box
          bgColor={"#f4f6f8"}
          p="10px"
          borderRadius={"5px"}
          boxSizing="border-box"
          color={"#27314D"}
          fontSize="14px"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          sx={{
            'ul>li': {
              marginLeft: "20px"
            }
          }}
        >
          {sessionContent.once && <span ref={ref}></span>}
          {!sessionContent.once &&<Markdown>{sessionContent.once == false ? sessionContent.message : ""}</Markdown>}
        </Box>
      </Box>
      <VStack spacing={"2px"} ml="4px">
        <IconButton
          minW="14px"
          boxSize="16px"
          icon={<RiRefreshLine size={"14px"} />}
          variant="unstyled"
          color={"#CBD1DF"}
          aria-label="刷新"
          borderRadius={0}
          // p={"4px"}
          _hover={{
            color: "#000",
          }}
          _focusVisible={{
            boxshadow: "none",
          }}
          onClick={() => reAnswer(sessionContent)}
        />
        <Menu direction="rtl" placement="right">
          <MenuButton
            as={IconButton}
            minW="18px"
            boxSize="18px"
            icon={<RiMore2Line size={"16px"} />}
            variant="unstyled"
            color={"#CBD1DF"}
            aria-label="操作"
            borderRadius={0}
            _hover={{
              color: "#000",
            }}
            _focusVisible={{
              boxshadow: "none",
            }}
          />

          <MenuList
            w="120px"
            minW={"90px"}
            bgColor="#fff"
            color={"#27314D"}
            borderColor={"#fff"}
            borderRadius={0}
            fontSize="14px"
            boxShadow={"md"}
            p="0"
          >
            <MenuItem icon={<RiCodeSLine size={"14px"} />}>显示原文</MenuItem>
            <MenuItem
              icon={<RiFileCopy2Line size={"14px"} />}
              onClick={handleCopy}
            >
              复制
            </MenuItem>
            {/* <MenuItem
              icon={<RiDeleteBin4Line size={"14px"} />}
              onClick={handleDelete}
            >
              删除
            </MenuItem> */}
          </MenuList>
        </Menu>
      </VStack>
    </Flex>
  );
};

export default AiSessionItem2;
